export function createId(prefix = 'ri'): string {
  return `${prefix}_${crypto.randomUUID()}`;
}
